<template>
  <main class="ws-page">
    <ws-exam-groups-list @exam-details="getExamDetails" />
  </main>
</template>

<script>
export default {
  name: 'ExamGroups',
  data () {
    return {
      exam: {}
    }
  },
  methods: {
    getExamDetails (e) {
      this.exam = e.exam
    }
  },
  mounted () {

  }
}
</script>
